import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const CradlePointApp = lazy(() => import('./CradlePointApp'));

const CradlePointAppConfig = {
    settings: {
        layout: {},
    },
    auth: authRoles.user,
    routes: [
        {
            path: 'apps/cradlePoint/configurations',
            element: <CradlePointApp />,
        }
    ],
};

export default CradlePointAppConfig;
